import React from 'react';
import { Button, Empty, Icon, Menu } from 'antd';
import styles from './MenuWithRemovedItems.module.scss';

const { Item } = Menu;

const isFn = (fn) => typeof fn === 'function';

const MenuWithRemovedItems = ({
  items = [],
  emptyText = 'Нет данных',
  valueKey = 'id',
  contentKey = 'name',
  handlers = {
    onDeleteItem: undefined,
    onReset: undefined,
    onMenuClick: undefined,
  },
  resetButtonText = 'Сбросить',
  resetButtonDisabled = false,
  ...props
}) => {
  const { onDeleteItem, onReset, onMenuClick } = handlers;

  return (
    <Menu
      {...props}
      className={styles.root}
      onClick={items.length > 0 ? onMenuClick : undefined}
    >
      {items.length === 0 ? (
        <Item>
          <Empty description={emptyText} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </Item>
      ) : (
        items.map((item) => (
          <Item key={item[valueKey]} value={item}>
            {item[contentKey]}
            {isFn(onDeleteItem) && (
              <Icon
                type="delete"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteItem(item);
                }}
              />
            )}
          </Item>
        ))
      )}
      {items.length > 0 && isFn(onReset) && (
        <Item className={styles.withoutPadding}>
          <Button
            className={styles.resetButton}
            block
            type="link"
            onClick={onReset}
            disabled={resetButtonDisabled}
          >
            {resetButtonText}
          </Button>
        </Item>
      )}
    </Menu>
  );
};

export default MenuWithRemovedItems;
